
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/settings",
      function () {
        return require("private-next-pages/dashboard/settings/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/settings"])
      });
    }
  